import { FRONTEND_HOST, } from "@/config/constants";
import { CarouselJsonLd, NextSeo } from "next-seo";
import { useRouter } from "next/router";
import MetaSeo from "./Meta";

const CourseListingSEO = (props: {
  title?: string;
  description?: string;
  data: { courseName: string; description: string; assortmentId: string; displayPrice: string }[];
}) => {
  const router = useRouter();
  const itemListElement = props.data.map((item, i) => ({
    "@type": "Course",
    "position": i + 1,
    "name": item.courseName,
    "description": item.description,
    "url": `${FRONTEND_HOST}/course/${item.assortmentId}`,
    "provider": {
      "@type": "Organization",
      "@id": `${FRONTEND_HOST}/#organization`,
    },
    "offers": {
      "@type": "Offer",
      "price": item.displayPrice,
      "priceCurrency": "INR",
      "availability": "http://schema.org/InStock",
      "validFrom": new Date().toISOString(),
      "category": "Online Education Course",
    },
    "hasCourseInstance": [   {
      "@type": "CourseInstance",
      courseMode: ["Online"],
      "courseSchedule" :{
        "@type": "Schedule",
        "repeatCount": "365",
        "repeatFrequency": "Daily"
      }
    }]
  }));

  return (
    <>
      <MetaSeo title={props.title || "Doubtnut - All Courses"} description={props.description} hasQuery/>
      <CarouselJsonLd
        url={FRONTEND_HOST}
        itemListElement={itemListElement}
        ofType="course"
        data={itemListElement}
      />
    </>
  );
};

export default CourseListingSEO;